import {NullableString} from "../../../common/types/nullable-types";

export interface IGetGamesRecommendationsOptions {
    maxGamesCount?: number;
    shouldFilterByRecentlyPlayed?: boolean;
    numberOfRecentlyPlayedGamesToFilterOut?: number
}

export interface GetTrendingGamesRecommendationsForPlayerOptions {
    recommendationTypes: TrendingRecommendationTypeEnum[];
}

export type TrendingGamesRecommendations = Record<TrendingRecommendationTypeEnum, number[]>;

export interface IAiRecommendationsReaderService {
    getRegularGamesRecommendations(options?: IGetGamesRecommendationsOptions): Promise<AIGamesRecommendations>;
    getRecentlyAddedGamesRecommendations(options?: IGetGamesRecommendationsOptions): Promise<AIGamesRecommendations>;
    getTrendingGamesRecommendationsForPlayer(options: GetTrendingGamesRecommendationsForPlayerOptions): Promise<TrendingGamesRecommendations>;
}

export interface AIGamesRecommendations {
    engine: NullableString;
    gameTypes: number[];
}

export enum TrendingRecommendationTypeEnum {
    Stickiness = 0,
    ActiveUsers = 1,
    Bets = 2
}

export const AiEngineTypes = {
    ML888:  "ML888"
}

export const AiEngineTypeId = {
    [AiEngineTypes.ML888]: 1
}